__turbopack_context__.v({
  "postCard": "AcPEqW_postCard",
  "postOverlay": "AcPEqW_postOverlay",
  "postTitle": "AcPEqW_postTitle",
});
